import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "prerequisite-b-icon",
  role: "img",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.913 12.331h-.918a1 1 0 0 1-1-1V7.33a1 1 0 1 1 2 0v1.73a12.988 12.988 0 1 1-1.915 8.387 1 1 0 1 1 1.987-.226 10.988 10.988 0 1 0 1.494-6.89h1.436a1 1 0 1 1 0 2H4.913Z" }, null, -1),
    _createElementVNode("path", { d: "M17.24 13.707a1.054 1.054 0 1 0 0 2.108 1.054 1.054 0 0 0 0-2.108Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.94 10.108a5.686 5.686 0 1 1 2.148 10.129l-2.119 2.123-.001.002a2.17 2.17 0 0 1-1.541.64h-1.252a2.177 2.177 0 0 1-2.178-2.177v-1.248a2.185 2.185 0 0 1 .634-1.535l.002-.002 2.13-2.134a5.687 5.687 0 0 1 2.177-5.798Zm5.545 1.595a3.686 3.686 0 0 0-5.656 4.173 1 1 0 0 1-.239 1.03l-2.539 2.545a.187.187 0 0 0-.054.129v1.245a.177.177 0 0 0 .178.178h1.252c.045 0 .09-.018.122-.05l.002-.003 2.536-2.541a1 1 0 0 1 1.038-.238 3.53 3.53 0 0 0 1.126.198h.005a3.686 3.686 0 0 0 2.229-6.666Z"
    }, null, -1)
  ])))
}
export default { render: render }